<template>
  <BaseDataTable
    :headers="headers"
    :paginatedItems="paginatedJobs"
    :item-class="getRowClass"
    @debouncedSearch="(searchKey) => setSearchNFetch(searchKey)"
    @optionsChanged="(options) => setTableOptionsNFetch(options)"
    table-key="table:jobOpportunities"
  >
    <template v-slot:actions="{ item }">
      <ShowJobDetailsButton :item="item" />
      <AcceptJobButton :item="item" />
      <RejectJobButton :item="item" />
      <ShowJobApplicantsButton :item="item" />
      <CloseJobButton :item="item" />
      <ReopenJobButton :item="item" />
      <ShowStatusChangeRequestsButton :item="item" />
    </template>
    <template v-slot:[`item.publisherName`]="{ item }">
      <RouterLink v-if="hasPermission(showPublisherPermission)" :to="'/job-publishers/'+item.publisher.id">
        {{ item.publisherName }}
      </RouterLink>
      <label v-else>  {{ item.publisherName }}</label>
    </template>
    <template v-slot:[`item.status`]="{ item }">
      {{ translateStatus(item.status) }}
    </template>
  </BaseDataTable>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { useJobOpportunitiesStore } from "../../store/JobOpportunitiesStore";
import JobOpportunity from "../../models/JobOpportunity";
import ShowJobDetailsButton from "../action_buttons/job_actions/ShowJobDetailsButton.vue";
import CloseJobButton from "../action_buttons/job_actions/CloseJobButton.vue";
import ReopenJobButton from "../action_buttons/job_actions/ReopenJobButton.vue";
import ShowJobApplicantsButton from "../action_buttons/job_actions/ShowJobApplicantsButton.vue";
import AcceptJobButton from "../action_buttons/job_actions/AcceptJobButton.vue";
import RejectJobButton from "../action_buttons/job_actions/RejectJobButton.vue";
import ShowStatusChangeRequestsButton from "../action_buttons/job_actions/ShowStatusChangeRequestsButton.vue";
import { RouterLink } from "vue-router";
import PermissionManagerMixin from "@/core/mixins/PermissionManagerMixin.vue";
import { READ_JOB_PUBLISHERS_PERMISSION } from "@/core/statics/Permissions";

export default {
  mixins:[PermissionManagerMixin],
  computed: {
    ...mapState(useJobOpportunitiesStore, ["paginatedJobs"]),
    ...mapWritableState(useJobOpportunitiesStore,["searchKey"]),
  },
  data() {
    return {
      showPublisherPermission:READ_JOB_PUBLISHERS_PERMISSION,
      headers: [
        { text: "الرقم", align: "start", value: "id" },
        { text: "المسمى الوظيفي", value: "title" },
        { text: "اسم الجهة الناشرة", value: "publisherName" },
        { text: "تاريخ الإضافة", value: "createdAt" },
        { text: "الحالة", value: "status" },
        { text: "عدد المتقدمين", value: "applicantsCount" },
        { text: "الإجراءات", sortable: false, value: "actions" },
      ],
    };
  },
  mounted() {
    this.fetchJobs();
  },
  methods: {
    ...mapActions(useJobOpportunitiesStore, [
      "fetchJobs",
      "setTableOptionsNFetch",
      "setSearchNFetch",
    ]),
   getRowClass(item) {
    if (item.pendingApplicantsCount > 0) {
      return 'row-highlight';
    }
    return '';
  },
    translateStatus(prop) {
      return JobOpportunity.trans(prop);
    },
  },
  components: {
    ShowJobDetailsButton,
    ShowJobApplicantsButton,
    CloseJobButton,
    ReopenJobButton,
    AcceptJobButton,
    RejectJobButton,
    ShowStatusChangeRequestsButton,
    RouterLink
  },
  destroyed(){
    this.searchKey=null;
  },
};
</script>
